import React, { useEffect, useRef, useState } from 'react';
import ActionDialog from 'jd-library/ActionDialog';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import historyHandler from 'jd-library/historyHandler';
import styles from './user_auth.scss';

const ModalComp = props => {
	let {heading,placeHolder,onHidden,onSubmit,type,serviceKey} = props;
	let subTxt = 'This is Testing Contract. You can test by entering your own '+(type=='mobile' ? 'number' : 'email address');
	const [mobOrEmail, setMobOrEmail] = useState('');
	let inputRegex = (type == 'mobile') ? /^(9|8|7|6)[0-9]{9}$/ : /^[a-zA-Z0-9][a-zA-Z0-9_\-\+]*(?:[\.][a-zA-Z0-9_\-\+]+)*\@(?:[a-zA-Z0-9_\-\+]+\.)+[a-zA-Z0-9_\-\+]*[a-zA-Z0-9]{2}$/;
	const [errMsg, setErrMsg] = useState('');
    const inputObj = {
        label: placeHolder,
        holderClass: 'inp-row',
        key: 'mobOrEmail',
        input: {
            value: mobOrEmail,
            autoFocus: true,
            type: (type == 'mobile'? 'tel' :type),
            onChange: e => {
				setErrMsg('');
				if(type == 'mobile'){
					let value = e.target.value;
					if(value) {
						let mobChangeRegex = /^(9|8|7|6)[0-9]{0,9}$/;
						if(!mobChangeRegex.test(value)) {
							return;
						}
					}
				}
				setMobOrEmail(e.target.value);
			}
        }
	};
	const validate = () => {
		let isError = false;
		if(type == 'mobile'){
			if(!mobOrEmail){
				setErrMsg('Please Enter Mobile Number');
				isError = true;
			}else if(!inputRegex.test(mobOrEmail)) {
				setErrMsg('Please Enter a valid Mobile Number');
				isError = true;
			}
		}else{
			if(!mobOrEmail){
				setErrMsg('Please Enter Email Address');
				isError = true;
			}else if(!inputRegex.test(mobOrEmail)) {
				setErrMsg('Please Enter a valid Email Address');
				isError = true;
			}
		}
		return !isError;
	}
	return (
		<>
            <ActionDialog
				onHidden={onHidden}
				settings={{
					modalId: 'secondModal',
					variant: 'action'
				}}
				title={heading}
				btnArray={[
					{
						variant: 'primary',
						children: 'Send Otp',
						clickHandler: () => {
							if(validate()){
								onSubmit(mobOrEmail, type, serviceKey);
                            	historyHandler.closeCurrent();
							}
                        }
					}
				]}
			>
				<div className={styles['hint-txt']}>{subTxt}</div>
				<InputWithMovingLabel
					label={inputObj.label}
					holderClass={inputObj.holderClass}
					input={inputObj.input}
					key={inputObj.key}
					errorMessage = {errMsg}
			    />
			</ActionDialog>
        </>
	);
};

export default ModalComp;
